import React from "react";
import { Navigate } from "react-router-dom";
import DashboardLoading from "@/components/dashboard/DashboardLoading";
import useSupabaseAuth from "@/v2/hooks/supabase/useAuth";
import { useSuperadminRole } from "@/hooks/superadmin/useSuperadminRole";
interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireSuperadmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireSuperadmin = false,
}) => {
  const { session: supabaseSession, loading } = useSupabaseAuth();
  const { isSuperadmin, isLoading: isSuperadminLoading } = useSuperadminRole();

  if (loading || (requireSuperadmin && isSuperadminLoading)) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 animate-in fade-in duration-100">
        <div className="mb-4 flex items-center space-x-2">
          <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-primary"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!supabaseSession) {
    return <Navigate to="/auth" replace />;
  }

  if (requireSuperadmin) {
    if (!isSuperadmin) {
      return <Navigate to="/auth" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
